module.exports = () => {
    $('.js-toggle-menu').click(() => {
        $('.js-side-menu').toggleClass('show closed');
        $('body').toggleClass('side-menu-open');
    });
};
